import { deepmerge } from '@utils/deepmerge'

export const buildChartJsOptionsProp = (options) => {
  return deepmerge({
    maintainAspectRatio: false,
    interaction: {
      mode: 'nearest',
      axis: 'x',
      intersect: false
    },
    plugins: {
      datalabels: false,
      legend: { position: 'bottom' },
    },
    scales: buildChartJsOptionsPropesOption(),
  }, options)
}

const buildChartJsOptionsPropesOption = () => {
  return {
    x: {
      display: false,
      border: {
        display: false
      },
      grid: {
        display: false,
      }
    },
    y: {
      display: false,
      border: {
        display: false
      },
      grid: {
        display: false
      },
    }
  }
}
